const CONTACT_MESSAGES_PATH = 'data/contact-messages.json';

export const fetchContactMessages = async () => {
  try {
    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${CONTACT_MESSAGES_PATH}`,
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      return {
        messages: JSON.parse(atob(data.content)),
        sha: data.sha
      };
    }
    return { messages: [], sha: null };
  } catch (error) {
    console.error('Error fetching contact messages:', error);
    return { messages: [], sha: null };
  }
};

export const saveContactMessage = async (message, existingMessages = [], sha = null) => {
  try {
    const newMessage = {
      id: Date.now().toString(),
      ...message,
      status: 'new',
      createdAt: new Date().toISOString()
    };

    const updatedMessages = [newMessage, ...existingMessages];
    const content = btoa(JSON.stringify(updatedMessages, null, 2));

    const body = {
      message: 'Add new contact message',
      content,
      branch: 'main'
    };

    if (sha) body.sha = sha;

    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${CONTACT_MESSAGES_PATH}`,
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      }
    );

    if (!response.ok) {
      throw new Error('Failed to save contact message');
    }

    return newMessage;
  } catch (error) {
    console.error('Error saving contact message:', error);
    throw error;
  }
};

export const updateMessageStatus = async (messageId, status, existingMessages, sha) => {
  try {
    const updatedMessages = existingMessages.map(msg => 
      msg.id === messageId ? { ...msg, status, updatedAt: new Date().toISOString() } : msg
    );

    const content = btoa(JSON.stringify(updatedMessages, null, 2));
    
    await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${CONTACT_MESSAGES_PATH}`,
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: `Update message ${messageId} status to ${status}`,
          content,
          sha,
          branch: 'main'
        })
      }
    );

    return updatedMessages;
  } catch (error) {
    console.error('Error updating message status:', error);
    throw error;
  }
};